<script>
import {cart} from "@/modules/cart";

export default {
  name: 'boxProductCart',
  computed: {
    cart() {
      return cart
    }
  },
  props: {
    productCart: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API_URL
    }
  }
}
</script>

<template>
  <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800 md:p-6">
    <div class="space-y-4 md:flex md:items-center md:justify-between md:gap-6 md:space-y-0">
      <router-link :to="'/boutique/' + productCart.products.tag" class="shrink-0 md:order-1">
        <img v-if="productCart.products.Images[0]" class="mx-auto h-32 dark:hidden" :src="`${apiUrl}${productCart.products.Images[0].url}`" alt="" />
        <img v-else class="mx-auto h-full" src="https://flowbite.s3.amazonaws.com/blocks/e-commerce/imac-front-dark.svg" alt="" />
      </router-link>

      <label for="counter-input" class="sr-only">Choose quantity:</label>
      <div class="flex items-center justify-between md:order-3 md:justify-end">
        <div class="flex items-center">
          x{{productCart.quantity}}
        </div>
        <div class="text-end md:order-4 md:w-32">
          <p class="text-base font-bold text-gray-900 dark:text-white">
            {{ productCart.products.price * productCart.quantity }} €
          </p>
        </div>
      </div>

      <div class="w-full min-w-0 flex-1 space-y-4 md:order-2 md:max-w-md">
        <a :href="'/boutique/' + productCart.products.slug" target="_blank" class="text-base font-medium text-gray-900 hover:underline dark:text-white">
          {{ productCart.products.title }}
        </a>

        <div class="flex items-center gap-4">
          <button type="button" class="inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-900 hover:underline dark:text-gray-400 dark:hover:text-white">
            <svg class="me-1.5 h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.01 6.001C6.5 1 1 8 5.782 13.001L12.011 20l6.23-7C23 8 17.5 1 12.01 6.002Z" />
            </svg>
          </button>

          <button @click="cart.removeProduct(productCart)" class="inline-flex items-center text-sm font-medium text-red-600 hover:underline dark:text-red-500">
            <svg class="me-1.5 h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18 17.94 6M18 18 6.06 6" />
            </svg>
            Remove
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
